import * as fromDatatype from '../datatype-library/index';
import {bl_fi_mst_shipping_price_book_event_RowInterface} from "./bl_fi_mst_shipping_price_book_event.model";

export interface bl_fi_mst_shipping_price_book_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  conditional_filter_json: fromDatatype.JsonDatatypeInterface;
  treatment_json: fromDatatype.JsonDatatypeInterface;
  price_book_type: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  usage_json: fromDatatype.JsonDatatypeInterface;
  pricing_bundle_json: fromDatatype.JsonDatatypeInterface;
  payment_logic_json: fromDatatype.JsonDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_mst_shipping_price_book_line_RowClass
  implements bl_fi_mst_shipping_price_book_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  conditional_filter_json: fromDatatype.JsonDatatypeInterface;
  treatment_json: fromDatatype.JsonDatatypeInterface;
  price_book_type: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  usage_json: fromDatatype.JsonDatatypeInterface;
  pricing_bundle_json: fromDatatype.JsonDatatypeInterface;
  payment_logic_json: fromDatatype.JsonDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
